export const USER = {
    GET_USER: "user/GET_USER",
    GET_UPDATE_INFORMATION: "user/GET_UPDATE_INFORMATION",
};
